// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabViewModel from "./../factories/tab-controller";
import TabPage from "./../factories/tab-page";
import SearchPaging from "./../factories/search-paging";
import baoRouter from "./../services/bao-router";
import ConfigurationItemAuditDialog from "./../factories/configuration-item-audit-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/foreach-selection";
import "./../bindings/slide-visible";
import "./../bindings/bao-tabs";
import "./../bindings/log";
import "./../bindings/bao-searcher";
import "./../bindings/bao-number-box";
import AppTabController from "../services/app-tab-controller";

function ConfigurationItemTypeDialog() {
    var self = this;
    self.Dialog = null;
    self.Bao = Bao;
    self.SelectedItem = ko.observable();
    self.Items = ko.observableArray();
    self.Deferred = $.Deferred();
    self.SelectItem = function (item) {
        self.Deferred.resolve(item);
        if (self.Dialog != null && self.Dialog.Close != null) {
            self.Dialog.Close();
        }
    };
    self.OpenDialog = function (configurationItemTypeCategoryKey) {
        Bao.post("ConfigurationItem/ConfigurationItemTypeDialog", JSON.stringify({
            configurationItemTypeCategoryKey: configurationItemTypeCategoryKey
        }), function (result) {
            if (result.Models != null && result.Models.length > 0) {
                self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                self.Dialog.Width("400px");
                self.Items(result.Models);
                self.Dialog.ViewModel(self);
                self.Dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        self.Deferred.resolve(self.SelectedItem());
                        self.Dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        self.Deferred.resolve();
                        self.Dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
                self.Dialog.Closed = function () {
                    self.Deferred.resolve();
                };
                self.Dialog.Template(result.Message);
                self.Dialog.Open();
            }
            else {
                self.Deferred.resolve(false);
            }
        });
        return self.Deferred.promise();
    };
}
function CITManufacturerTypeReferenceDocumentDialog() {
    var self = this;
    self.Dialog = null;
    self.Bao = Bao;
    self.SelectedItem = ko.observable();
    self.Items = ko.observableArray();
    self.Deferred = $.Deferred();
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(20);
    self.TotalRows = ko.observable(0);
    self.SelectItem = function (item) {
        self.Deferred.resolve(item);
        if (self.Dialog != null && self.Dialog.Close != null) {
            self.Dialog.Close();
        }
    };
    self.OpenDialog = function (ManufacturerId, ManufacturerTypeId) {
        Bao.post("ConfigurationItem/CITManufacturerTypeReferenceDocumentDialog", JSON.stringify({
            manufacturerId: ManufacturerId,
            manufacturerTypeId: ManufacturerTypeId,
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize()
        }), function (result) {
            if (result.Models != null && result.Models.length > 0) {
                self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
                self.Dialog.Width("400px");
                self.Items(result.Models);
                self.Dialog.ViewModel(self);
                self.TotalRows(result.TotalRows);
                self.Dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Click: function () {
                        self.Deferred.resolve();
                        self.Dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }, {
                    Title: Bao.Session.GetMessage("msgCancel"),
                    Click: function () {
                        self.Deferred.resolve();
                        self.Dialog.Close();
                    },
                    Enabled: ko.observable(true)
                }]);
                self.Dialog.Closed = function () {
                    self.Deferred.resolve();
                };
                self.Dialog.Template(result.Message);
                self.Dialog.Open();
            }
            else {
                self.Deferred.resolve(false);
            }
        });
        return self.Deferred.promise();
    };
    self.StartDownload = function (value) {
        self.Deferred.resolve();
        self.Dialog.Close();
        baoRouter.setHash("document/" + value);
    };
}
function ConfigurationItemViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.SettingsKeyPermissionApplicationId(window.SynosetApplicationId);
    self.SettingsKeyPermission('ConfigurationItemTypeContext');
    self.Bao = Bao;
    self.BaoMenu = BaoMenu;
    self.Parent = {};
    self.Owner = {};
    self.SelectedItem = ko.observable();
    self.Items = ko.observableArray();
    self.Deferred = $.Deferred();
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.ConfigurationItemId = ko.observable();
    self.SelectedManufacturer = ko.observable();
    self.SaveTime = ko.observable();
    self.ConfigurationItemTabCollection = ko.observableArray([]);
    self.ParentOwnerId = ko.observable();
    self.ConfigurationItemTypeId = ko.observable();
    self.SaveAllowed = ko.observable(true);
    self.DeleteAllowed = ko.observable(true);
    self.NewAllowed = ko.observable(true);
    self.IsNew = ko.observable(false);
    self.DisallowEditName = ko.observable();
    self.TabViewModel = new TabViewModel(false);
    self.Focus = function () { };
    self.SelectedConfigurationItemType = ko.observable();
    self.ShiftGroupMandatory = ko.observable(Bao.Session.Application.ApplicationId() === window.FinitoApplicationId);
    self.SelectedConfigurationItemType.subscribe(function (item) {
        self.DisallowEditName(item.DisallowEditName);
    });

    self.subscribe(self.ConfigurationItemTabCollection, function (newValue) {
        self.TabViewModel.Tabs([]);
        $.each(ko.map.toJS(newValue), function (index, item) {
            if (item.PreLoad == null) {
                item.PreLoad = false;
            }
            var newTab = new TabPage(null, item.Caption);
            newTab.AutoSelect = false;
            newTab.Url(item.WebUrl);
            newTab.IsClosable(false);
            newTab.PreLoad(item.PreLoad);
            self.TabViewModel.AddTab(newTab);
        });
        if (self.TabViewModel.Tabs().length > 0) {
            self.TabViewModel.SelectTab(self.TabViewModel.Tabs()[0]);
        }
    });
    self.subscribe(self.SelectedManufacturer, function () {
        self.ResetManufacturerType();
    });
    self.subscribe(self.ConfigurationItemTypeId, function (newValue) {
        if (self.Initialized() == true) {
            Bao.post("ConfigurationItem/GetTabsByConfigurationItemTypeId", JSON.stringify({
                configurationItemTypeId: newValue
            }), function (result) {
                tabPage.DirtyFlag.pause();
                self.ConfigurationItemTabCollection(result);
                tabPage.DirtyFlag.resume();
            });
            self.CheckPermissionsByType();
        }
        self.SettingsUrl(self.ConfigurationItemTypeId() ? 'ConfigurationItemType/' + self.ConfigurationItemTypeId() : null);
    });
    self.subscribe(self.SaveAllowed, function () {
        self.TogglePermissionsByType();
    });
    self.subscribe(self.DeleteAllowed, function () {
        self.TogglePermissionsByType();
    });
    self.subscribe(self.NewAllowed, function () {
        self.TogglePermissionsByType();
    });
    self.subscribe(self.IsNew, function (value) {
        self.BaoMenu.permissionEnable({ ActionKey: self.PermissionRefresh, Enabled: !value, Context: self.TabPage.Context() });
    });
    self.GenerateConfigurationItemName = function () {
        Bao.post("ConfigurationItem/GenerateConfigurationItemName", JSON.stringify({
            configurationItemTypeId: ko.unwrap(self.ConfigurationItemTypeId)
        }), function (result) {
            self.Name1(result);
        });
    };
    self.GoToCreationWizard = function () {
        var newTab = new TabPage();
        newTab.Url("CreationWizard");
        newTab.ObjectId("creationWizard" + self.ConfigurationItemId());
        newTab["Object"] = {
            rootId: self.ConfigurationItemId(),
            rootobjectName: self.Name1()
        };
        newTab.Title = Bao.Session.GetMessage("msgCreationWizardCaption");
        AppTabController.AddTab(newTab);
    };
    self.GoToParentConfigurationItem = function () {
        Bao.post("ConfigurationItem/GetConfigurationItemUrl", JSON.stringify({
            configurationItemId: self.ParentConfigurationItemId()
        }), function (result) {
            if (!Bao.Utils.String.IsNullOrEmpty(result)) {
                baoRouter.setHash(result);
            }
        });
    };
    self.ParentConfigurationItemDeleted = function () {
        self.ParentConfigurationItemName(null);
    };
    self.ResetManufacturerType = function () {
        self.ManufacturerTypeName("");
        self.ManufacturerTypeId(null);
    };
    self.ParentConfigurationItemChanged = function (selectedRow) {
        if (selectedRow != null) {
            self.ParentOwnerId(selectedRow.OwnerId);
        }
        else {
            self.ParentOwnerId(null);
        }
    };
    self.TogglePermissionsByType = function () {
        if (self.IsNew()) {
            BaoMenu.permissionEnable({
                ActionKey: self.PermissionSave,
                Enabled: self.NewAllowed(),
                Context: tabPage.Context()
            });
        }
        else {
            BaoMenu.permissionEnable({
                ActionKey: self.PermissionSave,
                Enabled: self.SaveAllowed(),
                Context: tabPage.Context()
            });
        }
        BaoMenu.permissionEnable({
            ActionKey: self.PermissionDelete,
            Enabled: self.DeleteAllowed(),
            Context: tabPage.Context()
        });
    };
    self.CheckPermissionsByType = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItem/CheckPermissionsByType", JSON.stringify({
            configurationItemTypeId: self.ConfigurationItemTypeId()
        }), function (result) {
            self.SaveAllowed(result.saveAllowed);
            self.DeleteAllowed(result.deleteAllowed);
            self.NewAllowed(result.newAllowed);
            tabPage.IsLoading(false);
        });
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.ConfigurationItemTypeId() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(self.Name1())) {
            isComplete = false;
        }
        if (self.ConfigurationItemStatusId() == null) {
            isComplete = false;
        }
        var latValue = self.Lat();
        var indexValueLat = 3;
        if (latValue !== null && latValue.toString().lastIndexOf("-") !== -1) {
            indexValueLat = 4;
        }
        if (latValue !== null && (latValue.toString().lastIndexOf(".") > indexValueLat || latValue.toString().lastIndexOf(".") === -1 && latValue.toString().length > indexValueLat)) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidGps"), "info");
            return false;
        }
        var lonValue = self.Lon();
        var indexValueLon = 3;
        if (lonValue !== null && lonValue.toString().lastIndexOf("-") !== -1) {
            indexValueLon = 4;
        }
        if (lonValue !== null && (lonValue.toString().lastIndexOf(".") > indexValueLon || lonValue.toString().lastIndexOf(".") === -1 && lonValue.toString().length > indexValueLon)) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidGps"), "info");
            return false;
        }
        $.each(self.TabViewModel.Tabs(), function (index, tab) {
            if (tab.PreLoad()) {
                if (tab.ViewModel().CompleteCheck != null && !tab.ViewModel().CompleteCheck()) {
                    self.TabViewModel.SelectTab(tab);
                    isComplete = false;
                    return false;
                }
            }
            return null;
        });
        if (!isComplete) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.BeforeClose = function (fn) {
        if (tabPage.DirtyFlag() == true && self.SaveAllowed() === true) {
            var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
            questionDialog.DialogResult.subscribe(function (result) {
                if (result === true) {
                    if (self.CompleteCheck()) {
                        tabPage.IsLoading(true);
                        self.Save().done(function () {
                            self.UnlockConfigurationItem().then(function () {
                                tabPage.IsLoading(false);
                                self.DestroyObject();
                                fn();
                            });
                        });
                    }
                }
                else if (result === false) {
                    tabPage.IsLoading(true);
                    self.UnlockConfigurationItem().then(function () {
                        tabPage.IsLoading(false);
                        self.DestroyObject();
                        fn();
                    });
                }
            });
        }
        else {
            self.UnlockConfigurationItem().then(function () {
                self.DestroyObject();
                fn();
            });
        }
    };
    self.UnlockConfigurationItem = function () {
        return Bao.post("ConfigurationItem/UnlockConfigurationItem", JSON.stringify({
            sessionTabId: tabPage.SessionTabId
        }));
    };
    self.PerformRefresh = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.ConfigurationItemId()
        }), function (value) {
            tabPage.DirtyFlag.pause();
            tabPage.ObjectId(value.ConfigurationItemId);
            delete value.ConfigurationItemTabCollection;
            ko.map.fromJS(value, self);
            self.TabViewModel.RefreshTabs().then(function () {
                tabPage.IsLoading(false);
                tabPage.DirtyFlag.reset();
            });
        });
    };
    self.MinimizeEntity = function () {
        var result = ko.map.toJS(self, true);
        delete result.Owner;
        delete result.Parent;
        delete result.Customer;
        delete result.ConfigurationItemTabCollection;
        delete result.AssignmentTypes;
        delete result.Bao;
        delete result.TabPage;
        delete result.Destroy;
        delete result.TabViewModel;
        delete result.subscriptions;
        return result;
    };
    self.Save = function () {
        var def = $.Deferred();
        if (self.IsNew() == true) {
            self.HasReminderDefinition().then(function (reminderDefResult) {
                if (reminderDefResult == true) {
                    var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddReminderByDefinition"), "yesno");
                    questionDialog.DialogResult.subscribe(function (result) {
                        if (result === true) {
                            self.SaveCall(true).then(function () {
                                def.resolve();
                            });
                        }
                        else {
                            self.SaveCall(false).then(function () {
                                def.resolve();
                            });
                        }
                    });
                }
                else {
                    self.SaveCall(false).then(function () {
                        def.resolve();
                    });
                }
            });
        }
        else {
            self.SaveCall(false).then(function () {
                def.resolve();
            });
        }
        return def.promise();
    };
    self.HasReminderDefinition = function () {
        return Bao.post("ConfigurationItemTab/HasReminderDefinition", JSON.stringify({
            configurationItemTypeId: self.ConfigurationItemTypeId(),
            countryId: self.CountryId(),
            stateId: self.StateId()
        }));
    };
    self.AddReminderByDefinition = function () {
        return Bao.post("ConfigurationItemTab/AddReminderByDefinition", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            configurationItemId: self.ConfigurationItemId(),
            configurationItemTypeId: self.ConfigurationItemTypeId(),
            countryId: self.CountryId(),
            stateId: self.StateId()
        }));
    };
    self.SaveCall = function (addReminder) {
        return Bao.post(self.SaveUrl, JSON.stringify({
            model: self.MinimizeEntity(),
            addReminderByDefinition: addReminder
        })).then(function (value) {
            self.SaveTime(value.Result);
            return self.TabViewModel.SaveTabs(value.Result);
        }).then(function () {
            tabPage.DirtyFlag(false);
            self.PerformRefresh();
            self.TogglePermissionsByType();
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.DeleteUrl, JSON.stringify({
            id: self.ConfigurationItemId()
        }), function () {
            tabPage.IsLoading(false);
            tabPage.DirtyFlag(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "CreationWizardFromObject":
                    self.GoToCreationWizard();
                    break;
                case "GenerateConfigurationItemName":
                    self.GenerateConfigurationItemName();
                    break;
                case self.PermissionAuditTrail:
                    self.OpenConfigurationItemAuditDialog();
                    break;
            }
        }
    }));
    self.RefreshParent = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: self.ParentConfigurationItemId()
        }), function (result) {
            ko.map.fromJS(result, self.Parent);
            tabPage.IsLoading(false);
        });
    };
    self.RefreshOwner = function () {
        tabPage.IsLoading(true);
        return Bao.post(self.RefreshUrl, JSON.stringify({
            configurationItemId: self.OwnerId()
        }), function (result) {
            ko.map.fromJS(result, self.Owner);
            tabPage.IsLoading(false);
        });
    };
    self.InitConfigurationItem = function (configurationItemTypeId) {
        return Bao.post(self.RefreshUrl, JSON.stringify({
            id: tabPage.UrlData().id,
            parent: tabPage.UrlData().parent,
            configurationItemTypeId: configurationItemTypeId
        }), function (model) {
            ko.map.fromJS(model, self, tabPage.DirtyFlag);
            tabPage.SessionTabId = self.SessionTabId();
            if (self.IsNew()) {
                tabPage.ObjectId(self.ConfigurationItemId());
            }
            else {
                tabPage.ObjectId.valueHasMutated();
            }
        });
    };
    self.init = function () {
        var def = $.Deferred();
        if (tabPage.UrlData().id == null) {
            var configurationItemTypeDialog = new ConfigurationItemTypeDialog();
            configurationItemTypeDialog.OpenDialog(self.ConfigurationItemTypeKeyCategory).then(function (configurationItemType) {
                var configurationItemTypeId = null;
                if (configurationItemType != null) {
                    if (configurationItemType !== false) {
                        configurationItemTypeId = configurationItemType.ConfigurationItemTypeId;
                    }
                    self.InitConfigurationItem(configurationItemTypeId).then(function () {
                        def.resolve();
                    });
                }
                else {
                    tabPage.$TabController.RemoveTab(tabPage);
                }
            });
        }
        else {
            return self.InitConfigurationItem(null);
        }
        return def.promise();
    };
    self.loaded = function () {
        self.InitPaging();
        tabPage.DirtyFlag.reset();
        tabPage.IsLoading(false);
        self.Initialized(true);
        self.QrLabel(self.Name1());
        if (tabPage.Object != null && tabPage.Object.OwnerId != null) {
            self.OwnerId(tabPage.Object.OwnerId);
            self.Owner.FullName(tabPage.Object.OwnerName);
        }
        self.Focus();
    };
    self.ShowManufacturerTypeReferenceDocument = function () {
        var cITManufacturerTypeReferenceDocumentDialog = new CITManufacturerTypeReferenceDocumentDialog();
        cITManufacturerTypeReferenceDocumentDialog.OpenDialog(self.ManufacturerId(), self.ManufacturerTypeId()).then(function () { });
    };
    self.MsgAuditTrailDialogTitle = Bao.Session.GetMessage("AuditTrailDialogTitle");
    self.OpenConfigurationItemAuditDialog = function () {
        var configurationItemAuditDialog = new ConfigurationItemAuditDialog(self.ConfigurationItemId(), ko.unwrap(self.TabName), tabPage);
        configurationItemAuditDialog.Open();
    };
}
Bao.inherit(ConfigurationItemViewModel, SearchPaging);
ConfigurationItemViewModel.prototype.PrimaryKey = "ConfigurationItemId";
ConfigurationItemViewModel.prototype.RefreshUrl = "ConfigurationItem/GetConfigurationItem";
ConfigurationItemViewModel.prototype.SaveUrl = "ConfigurationItem/SaveConfigurationItem";
ConfigurationItemViewModel.prototype.DeleteUrl = "ConfigurationItem/DeleteObject";
ConfigurationItemViewModel.prototype.DeleteMessageKey = "msgDeleteConfigurationItem";
ConfigurationItemViewModel.prototype.PermissionForward = "ConfigurationItemMoveForwardSearch";
ConfigurationItemViewModel.prototype.PermissionBackward = "ConfigurationItemMoveBackwardSearch";
ConfigurationItemViewModel.prototype.PermissionRefresh = "ConfigurationItemRefresh";
ConfigurationItemViewModel.prototype.PermissionSave = "ConfigurationItemSave";
ConfigurationItemViewModel.prototype.PermissionDelete = "ConfigurationItemDelete";
ConfigurationItemViewModel.prototype.PermissionQRCode = "ConfigurationItemQRCode";
ConfigurationItemViewModel.prototype.ConfigurationItemTypeKeyCategory = "Object";
ConfigurationItemViewModel.prototype.PermissionAuditTrail = "ConfigurationItemAudit";
export default ConfigurationItemViewModel;